import React, { useState, useContext, useEffect } from "react";
import {
  List,
  Card,
  Form,
  Radio,
  Grid,
  Button,
  Header,
  Container,
  Popup,
  Icon,
  Message,
} from "semantic-ui-react";
import PopDialog from "./popupdialog";
import AddNotes from "../pages/addNote";
import { withRouter } from "react-router-dom";
import { ContextProvider } from "../providers/app.provider";
import { save } from "save-file";

let timeout = "";

const CommonQuestions = ({ history, OrderType }) => {
  const {
    userDetails,
    notes,
    notesDispatch,
    indicatorDispatch,
    userDispatch,
  } = useContext(ContextProvider);

  const [CommonQuestionsState, setSate] = useState({
    licenseType: "perpetual",
    dsmAndAgent: "dsmAndAgent",
    isVTE: "no",
    isLDT: "no",
    ldtAndVteCount: "yes",
    isProdAndNonprod: "no",
    dsmType: "entDSM",
    dsmBreakDown: "",
  });
  const [modalOpen, setOpen] = useState(false);
  const [popUpText, setPopUpText] = useState({
    popUpHeader: "",
    popUpContent: "",
    popUpStatus: false,
  });
  const { popUpHeader, popUpContent, popUpStatus } = popUpText;

  const {
    licenseType,
    dsmAndAgent,
    isVTE,
    isLDT,
    ldtAndVteCount,
    isProdAndNonprod,
    dsmType,
    dsmBreakDown,
  } = CommonQuestionsState;

  const handleSetPopUpText = (header, content, status) => {
    setPopUpText({
      popUpHeader: header,
      popUpContent: content,
      popUpStatus: status,
    });
    timeout = setTimeout(() => {
      setPopUpText({ popUpHeader: "", popUpContent: "", popUpStatus: false });
    }, 8000);
  };

  const handleMouseEnter = () => {
    clearTimeout(timeout);
  };

  const handleMouseLeave = () => {
    setPopUpText({ popUpHeader: "", popUpContent: "", popUpStatus: false });
    clearTimeout(timeout);
  };

  const handleChange = (event, { value, name }) => {
    setSate({ ...CommonQuestionsState, [name]: value });
  };
  const handleTextAreaChange = (value, name) => {
    setSate({ ...CommonQuestionsState, [name]: value });
  };
  const resetVteStatus = () => {
    setSate({ ...CommonQuestionsState, isLDT: "no" });
  };

  const openModal = () => {
    setOpen(!modalOpen);
  };
  const closeModal = () => {
    setOpen(false);
  };
  const reset = () => {
    setSate({
      licenseType: "perpetual",
      dsmAndAgent: "dsmAndAgent",
      isVTE: "no",
      isLDT: "no",
      ldtAndVteCount: "yes",
      isProdAndNonprod: "no",
      dsmType: "entDSM",
      dsmBreakDown: "",
    });
    setOpen(false);
  };

  const details = {
    title: "Break Down",
    header:
      "Please Provide the breakdown on how many agents should be allocated between Prod and NonProd DSM",
    content: ["Please contact SE or the customer for more details."],
  };

  const goBack = () => {
    history.goBack();
  };

  const handleSubmit = () => {
    const obj = {
      "user details": {
        name: userDetails.username,
        email: userDetails.email,
        phone: userDetails.phone,
      },
      OrderType: OrderType,
      "license type": licenseType,
      "DSM,Agent or Both": dsmAndAgent==="dsmAndAgent" ? "DSM and Agent": dsmAndAgent,
      "license breakdown details": dsmBreakDown,
      Notes: notes,
    };
    const newLocal = JSON.stringify(obj, null, 2);
    save(`${userDetails.sfdcId}.txt`, newLocal);
    reset();
    notesDispatch({ type: "NOTES_RESET", payload: "" });
    userDispatch({ type: "USER_DETAILS_RESET" });
    history.push("/");
  };

  const [disabled, setDisabled] = useState(false);
  const disabledSaveButton = (OrderType) => {
    if (
      OrderType === "New Customer" ||
      OrderType === "New BU/Separate License/new DSM license"
    ) {
      if (
        dsmAndAgent === "dsm" ||
        dsmAndAgent === "agent" ||
        ldtAndVteCount === "no"
      ) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
  };

  useEffect(() => {
    disabledSaveButton(OrderType);
    indicatorDispatch({ type: "INDICATOR_SUBMIT", payload: OrderType });
  }, [OrderType, disabled, dsmAndAgent, dsmAndAgent, ldtAndVteCount]);

  const dsmAndAgentShowOrHide = () => {
    return dsmAndAgent === "dsm" || dsmAndAgent === "agent";
  };

  return (
    <>
      <Container
        style={{
          paddingTop: "10px",
          paddingLeft: "20px",
          paddingRight: "20px",
        }}
      >
        {OrderType !== "Add On" ? (
          <span>
            <Popup
              on="click"
              wide
              open={popUpStatus}
              trigger={<span></span>}
              style={{
                position: "relative",
                right: "-211%",
                padding: "0px",
                top: "-20px",
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Popup.Content>
                <Message warning>
                  <Message.Header>
                    <Icon name="info circle" color="yellow" />
                    {popUpHeader}
                  </Message.Header>
                  <p>{popUpContent}</p>
                </Message>
              </Popup.Content>
            </Popup>
          </span>
        ) : null}

        <Header as="h3">This is an order for {OrderType}</Header>
        <PopDialog
          modalOpen={modalOpen}
          closeModal={closeModal}
          details={details}
          status={true}
          onSubmit={() => {}}
          handleChange={handleTextAreaChange}
          value={dsmBreakDown}
          reset={() => {}}
        />
        <Form style={{ paddingBottom: "10px" }}>
          <List>
            <List.Item>
              <Card fluid>
                <Card.Content>
                  <Card.Header>License Type</Card.Header>
                  <Grid columns="equal">
                    <Grid.Column>
                      <Form.Field>
                        <Radio
                          label="Perpetual"
                          name="licenseType"
                          value="perpetual"
                          checked={licenseType === "perpetual"}
                          onChange={handleChange}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column>
                      <Form.Field>
                        <Radio
                          label="Term"
                          name="licenseType"
                          value="term"
                          checked={licenseType === "term"}
                          onChange={handleChange}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column>
                      <Form.Field>
                        <Radio
                          label="Subscription"
                          name="licenseType"
                          value="subscription"
                          checked={licenseType === "subscription"}
                          onChange={handleChange}
                        />
                      </Form.Field>
                    </Grid.Column>
                  </Grid>
                </Card.Content>
              </Card>
            </List.Item>
            <List.Item>
              <Card fluid>
                <Card.Content>
                  <Card.Header>
                    Q1 - Please choose DSM type from below:
                  </Card.Header>
                  <Grid columns="equal">
                    <Grid.Column>
                      <Form.Field>
                        <Radio
                          label="Enterprise DSM"
                          name="dsmType"
                          value="entDSM"
                          checked={dsmType === "entDSM"}
                          onChange={handleChange}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column>
                      <Form.Field>
                        <Radio
                          label="DSM-25"
                          name="dsmType"
                          value="dsm25"
                          checked={dsmType === "dsm25"}
                          onChange={handleChange}
                          onClick={() =>
                            handleSetPopUpText(
                              "You have chosen DSM25",
                              "Please make sure the total agent count is not greater than 25.",
                              true
                            )
                          }
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column>
                      <Form.Field>
                        <Radio
                          label="DSM-10"
                          name="dsmType"
                          value="dsm10"
                          checked={dsmType === "dsm10"}
                          onChange={handleChange}
                          onClick={() =>
                            handleSetPopUpText(
                              "You have chosen DSM10",
                              "Please make sure the total agent count is not greater than 10.",
                              true
                            )
                          }
                        />
                      </Form.Field>
                    </Grid.Column>
                  </Grid>
                </Card.Content>
              </Card>
            </List.Item>
            <List.Item>
              <Card fluid>
                <Card.Content>
                  <Card.Header>
                    Q2 - Please choose one from below that applies to this
                    order:
                  </Card.Header>
                  <Grid columns="equal">
                    <Grid.Column>
                      <Form.Field>
                        <Radio
                          label="DSM only"
                          name="dsmAndAgent"
                          value="dsm"
                          checked={dsmAndAgent === "dsm"}
                          onChange={handleChange}
                          onClick={() =>
                            handleSetPopUpText(
                              "You have chosen DSM only",
                              "Please be advised that at least one DSM and one agent are needed in order to create a license.",
                              true
                            )
                          }
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column>
                      <Form.Field>
                        <Radio
                          label="Agent only"
                          name="dsmAndAgent"
                          value="agent"
                          checked={dsmAndAgent === "agent"}
                          onChange={handleChange}
                          onClick={() =>
                            handleSetPopUpText(
                              "You have chosen agent only",
                              "Please be advised that an agent can not work alone without a DSM, vice versa.",
                              true
                            )
                          }
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column>
                      <Form.Field>
                        <Radio
                          label="DSM and Agent"
                          name="dsmAndAgent"
                          value="dsmAndAgent"
                          checked={dsmAndAgent === "dsmAndAgent"}
                          onChange={handleChange}
                        />
                      </Form.Field>
                    </Grid.Column>
                  </Grid>
                </Card.Content>
              </Card>
            </List.Item>
            {!dsmAndAgentShowOrHide() ? (
              <>
                <List.Item>
                  <Card fluid>
                    <Card.Content>
                      <Card.Header>Q3 - Is this a VTE order?</Card.Header>
                      <Grid columns="equal">
                        <Grid.Column>
                          <Form.Field>
                            <Radio
                              label="Yes"
                              name="isVTE"
                              value="yes"
                              checked={isVTE === "yes"}
                              onChange={handleChange}
                            />
                          </Form.Field>
                        </Grid.Column>
                        <Grid.Column>
                          <Form.Field>
                            <Radio
                              label="No"
                              name="isVTE"
                              value="no"
                              checked={isVTE === "no"}
                              onChange={handleChange}
                              onClick={resetVteStatus}
                            />
                          </Form.Field>
                        </Grid.Column>
                      </Grid>
                    </Card.Content>
                  </Card>
                </List.Item>
                {isVTE !== "no" ? (
                  <>
                    <List.Item>
                      <Card fluid>
                        <Card.Content>
                          <Card.Header>
                            Q4 - Does the order include LDT?
                          </Card.Header>
                          <Grid columns="equal">
                            <Grid.Column>
                              <Form.Field>
                                <Radio
                                  label="Yes"
                                  name="isLDT"
                                  value="yes"
                                  checked={isLDT === "yes"}
                                  onChange={handleChange}
                                />
                              </Form.Field>
                            </Grid.Column>
                            <Grid.Column>
                              <Form.Field>
                                <Radio
                                  label="No"
                                  name="isLDT"
                                  value="no"
                                  checked={isLDT === "no"}
                                  onChange={handleChange}
                                />
                              </Form.Field>
                            </Grid.Column>
                          </Grid>
                        </Card.Content>
                      </Card>
                    </List.Item>
                    {isLDT !== "no" ? (
                      <List.Item>
                        <Card fluid>
                          <Card.Content>
                            <Card.Header>
                              Q5 - Is total LDT less than or equal to total VTE
                              count?
                            </Card.Header>
                            <Grid columns="equal">
                              <Grid.Column>
                                <Form.Field>
                                  <Radio
                                    label="Yes"
                                    name="ldtAndVteCount"
                                    value="yes"
                                    checked={ldtAndVteCount === "yes"}
                                    onChange={handleChange}
                                  />
                                </Form.Field>
                              </Grid.Column>
                              <Grid.Column>
                                <Form.Field>
                                  <Radio
                                    label="No"
                                    name="ldtAndVteCount"
                                    value="no"
                                    checked={ldtAndVteCount === "no"}
                                    onChange={handleChange}
                                    onClick={() =>
                                      handleSetPopUpText(
                                        "Incorrect License configuration",
                                        "The total LDT count should be less or equal to total VTE count",
                                        true
                                      )
                                    }
                                  />
                                </Form.Field>
                              </Grid.Column>
                            </Grid>
                          </Card.Content>
                        </Card>
                      </List.Item>
                    ) : null}
                  </>
                ) : null}
              </>
            ) : null}
            <List.Item>
              <Card fluid>
                <Card.Content>
                  <Card.Header>
                    Final Question - Does the order have Prod and NonProd DSMs?
                  </Card.Header>
                  <Grid columns="equal">
                    <Grid.Column>
                      <Form.Field>
                        <Radio
                          label="Yes"
                          name="isProdAndNonprod"
                          value="yes"
                          checked={isProdAndNonprod === "yes"}
                          onChange={handleChange}
                          onClick={openModal}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column>
                      <Form.Field>
                        <Radio
                          label="No"
                          name="isProdAndNonprod"
                          value="no"
                          checked={isProdAndNonprod === "no"}
                          onChange={handleChange}
                        />
                      </Form.Field>
                    </Grid.Column>
                  </Grid>
                </Card.Content>
              </Card>
            </List.Item>
          </List>
        </Form>
        <Button onClick={handleSubmit} color="blue" disabled={disabled}>
          Save
        </Button>
        <Button onClick={goBack} color="black">
          Back
        </Button>
        <Button onClick={reset} color="grey">
          Reset
        </Button>
        <AddNotes />
      </Container>
    </>
  );
};

export default withRouter(CommonQuestions);
